import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogleScholar, faMedium } from '@fortawesome/free-brands-svg-icons';
import './writing.css';

const writings = [
  {
    icon: faGoogleScholar,
    title: 'Research Articles',
    description: 'My publications and academic research.',
    url: 'https://scholar.google.com/citations?user=66EGQbgAAAAJ&hl=id',
    cta: 'View Scholar Profile',
  },
  {
    icon: faMedium,
    title: 'Medium Articles',
    description: 'Write-ups and articles about cybersecurity and tech.',
    url: 'https://medium.com/@siddiqodiq',
    cta: 'Read on Medium',
  },
];

const Writing = () => {
  return (
    <section className="writing section" id="writing">
      <h2 className="section__title">Writing</h2>
      <span className="section__subtitle">My Articles and Research</span>

      <div className="writing__container container">
        {writings.map(({ icon, title, description, url, cta }) => (
          <div key={title} className="writing__card">
            <FontAwesomeIcon icon={icon} className="writing__icon" />
            <h3 className="writing__title">{title}</h3>
            <p className="writing__description">{description}</p>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="button button--flex writing__button"
            >
              {cta}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Writing;
